export class Indication {
    uid: string;
    email: string;
    companyUID: string;
    date: number;
    status: IndicationStatus;
    name: string;
    contactEmail: string;
    contactName: string;
    contactPhone: string;
}

export enum IndicationStatus {
    NEW = 1,
    APPROVED = 2
}



// WEBPACK FOOTER //
// ./src/app/model/indication.ts